import { TextField } from '@mui/material';
import { ChangeEvent, ComponentProps } from 'react';
import styled from 'styled-components';

// const StyledInput = styled.div`
//   padding: 8px 12px;
//   border: 1px solid #000000;
//   border-radius: 4px;
//   input {
//     border: 0;
//     outline: 0;
//     width: 100%;
//     &:focus {
//       border: 0;
//       outline: 0;
//     }
//   }
// `;

type PropTypes = {
  value: string;
  onChange: (val: string) => void;
} & intpuType;
type intpuType = Omit<ComponentProps<typeof TextField>, 'value' | 'onChange'>;

export default function Input({ value, onChange, ...props }: PropTypes) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };
  return (
      <TextField value={value} onChange={handleChange} size='small' fullWidth {...props}/>

  );
}
